export class ScheduledMaintenanceTask {
    TaskTypeName: string;
    Name: string;
    Description: string;
    AvailableConfigurationSettings: any;
    DefaultConfiguration: any;
}

export class ScheduledMaintenanceTaskTenantDetails {
    ScheduledMaintenanceTaskId: number;
    TenantId: string;
    Status: string;
    JobId: string;
    Name: string;
}

export class ScheduledMaintenanceTaskDetails {
    TypeName: string;
    StartDate: Date;
    TimeZoneId: string;
    Configuration: any;
    Tenants: ScheduledMaintenanceTaskTenantDetails[];
    ApplyToAllTenants: boolean;
    RecurringScheduledMaintenanceTaskSeriesId?: number;
    OccurrenceLocalStartDateTime?: Date;
}

export enum ScheduledMaintenanceTaskStatus
{
    NotStarted = 'NotStarted',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    Unknown = 'Unknown'
}
